import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { FormInputText } from "../../../components/form-components/FormInputText";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { productSchema } from "../../../app/schema";
import { useDispatch, useSelector } from "react-redux";
import FormTextEditor from "../../../components/form-components/FormTextEditor";
import { FormAutoComplete } from "../../../components/form-components/FormAutoComplete";
import {
  defaultDropDown,
  extractAfterLastUnderscore,
  parseArray,
  parseArrayToString,
} from "../../../app/utlils";
import { FormInputMultiCheckbox } from "../../../components/form-components/FormInputMultiCheckbox";
import ProductVariation from "./ProductVariation";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { showModal, shapeList } from "../../../redux/counterSlice";
import Loader from "../../../components/loader/Loader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FormInputTextArea } from "../../../components/form-components/FormInputTextArea";
import ProductRegionBasedAttributes from "./ProductRegionBasedAttributes";
import ProductMultiRegion from "./ProductMultiRegion";

function ProductForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();

  const {
    taxList,
    categoryList,
    subCategoryList,
    unitList,
    flavourList,
    shapeList,
    regionList,
    categoryCodeList,
    // flatPriceList,
  } = useSelector((state) => state.counter);

  const [productData, setProductData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [weightList, setWeightList] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [openMultiRegion, setOpenMultiRegion] = useState(false);
  const [productList, setProductList] = useState([]);
  const [deletedVariationIds, setDeletedVariationIds] = useState([]);

  const handleProductMultiRegion = () => {
    setOpenMultiRegion(true);
  };

  const handleCloseMultiRegion = () => {
    setOpenMultiRegion(false);
  };
  const handleMultiRegionSave = (newSelectedRegions) => {
    setValue("product_tags", newSelectedRegions);
  };

  const methods = useForm({
    resolver: yupResolver(productSchema),
    defaultValues: {
      product_name: productData?.product_name,
    },
  });

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    reset,
    clearErrors,
    watch,
    resetField,
    formState: { errors },
  } = methods;
  console.log(errors);
  const onSubmit = (data) => {
    const { cod, region = [], variation: _v, ...remainingPayload } = data;

    const currentVariations =
      data?.variation && data.variation.length > 0
        ? data.variation
        : getValues("variation") || [];

    const variationIds = currentVariations
      .map((v) => v.variation_id || v.id)
      .filter((vId) => vId && !String(vId).startsWith("temp-"))
      .join(",");

    const weightIds = currentVariations
      .map((v) => v.weight_id || v.weight)
      .filter(Boolean)
      .join(",");

    const formattedVariations = currentVariations.map((v) => ({
      id: v.id || v.variation_id || null,
      variation_id: v.variation_id || v.id || null,
      weight:
        v.weight !== "" && v.weight !== undefined
          ? Number(v.weight)
          : v.weight_id !== "" && v.weight_id !== undefined
          ? Number(v.weight_id)
          : 0,
      weight_id:
        v.weight_id !== "" && v.weight_id !== undefined
          ? Number(v.weight_id)
          : v.weight !== "" && v.weight !== undefined
          ? Number(v.weight)
          : 0,
      egg: String(v.egg ?? ""),
      eggLess: String(v.eggLess ?? v.eggless ?? "0"),
      eggless: String(v.eggLess ?? v.eggless ?? "0"),
      eggPreparation: String(v.eggPreparation ?? v.egg_preparation ?? 0),
      egg_preparation: String(v.egg_preparation ?? v.eggPreparation ?? 0),
      egglessPreparation: String(
        v.egglessPreparation ?? v.eggless_preparation ?? 0
      ),
      eggless_preparation: String(
        v.eggless_preparation ?? v.egglessPreparation ?? 0
      ),
      sku: v.sku || "",
    }));

    const payload = {
      variation: formattedVariations,
      variation_ids: variationIds,
      weight_ids: weightIds,
      deleted_variation_ids: deletedVariationIds,
      deleted_variations: deletedVariationIds,
      ...remainingPayload,
      COD_egg: data?.cod?.includes("egg") ? 1 : 0,
      COD_eggless: data?.cod?.includes("eggless") ? 1 : 0,
      stream_engine: data?.stream_engine ? 1 : 0,
      category_id: Number(data?.category_id),
      sub_category_id: Number(data?.sub_category_id),
      unit_id: Number(data?.unit_id),
      tax_id: Number(data?.tax_id),
      cat_code_id: data?.cat_code_id || null,
      region: parseArray(data?.region)?.toString(),
      flavour: parseArray(data?.flavour)?.toString(),
      combo_products: parseArray(data?.selectedProducts)?.toString(),
      combo_addons: parseArray(data?.selectedAddons)?.toString(),
      offer_fixed_price_id: data?.offer_fixed_price_id || null,
    };

    // If combo_price is present (not empty or zero), set tax_id to null
    if (data?.combo_price && Number(data?.combo_price) > 0) {
      payload.tax_id = 0;
    }

    saveForm(payload);
  };

  const selectedCategory = watch("category_id");
  const selectedSubCategory = watch("sub_category_id");
  const productName = watch("product_name");
  const unit = watch("unit_id");
  const selectedRegions = watch("region");
  const selectedProducts = watch("selectedProducts") || [];
  const selectedAddons = watch("selectedAddons") || [];
  const comboProductChecked = watch("combo_product") || false;
  const productShape = watch("product_shape") || false;
  const selectedFlavours = watch("flavour") || [];

  const totalComboPrice =
    ([...selectedProducts, ...selectedAddons]?.length > 0 &&
      [...selectedProducts, ...selectedAddons]?.reduce((sum, item) => {
        const matched = productList.find((p) => p.value === item.value);
        return sum + (matched?.price || 0);
      }, 0)) ||
    0;
  useEffect(() => {
    setLoader(true);
    const filteredSubCategories = subCategoryList?.filter(
      (item) => item?.category_id === selectedCategory,
    );
    setFilteredSubCategories((prev) => filteredSubCategories);
    // setValue("sub_category_id", "");
    setLoader(false);
  }, [selectedCategory, productData]);
  useEffect(() => {
    if (selectedSubCategory > 0) {
      const selectedSubCategoryData = subCategoryList.find(
        (item) => item.id === selectedSubCategory,
      );
      if (selectedSubCategoryData) {
        const { hsn, tax_id } = selectedSubCategoryData;
        setValue("hsn", hsn);
        setValue("tax_id", tax_id);
      }
    }
  }, [selectedSubCategory, subCategoryList]);
  useEffect(() => {
    loadWeightDataById(unit);
  }, [unit]);

  const saveForm = async (data) => {
    try {
      setLoader(true);
      let response;
      if (id > 0) {
        response = await axios.put("/product/" + id, data);
      } else {
        response = await axios.post("/product", data);
      }
      if (!response?.data?.error) {
        toast.success(response?.data?.message);
        navigate("/products");
        //  reset();
      } else {
        let errDesc = "";
        if (response?.data?.data) {
          Object.values(response?.data?.data).map((error, index) => {
            errDesc =
              index === 0 ? errDesc + error + "\n " : errDesc + error + "\n ";
          });
        } else {
          errDesc = response?.data?.message;
        }

        dispatch(
          showModal({
            msg: errDesc,
            error: response?.data?.error,
          }),
        );
      }
    } catch (error) {
      dispatch(
        showModal({
          msg: error?.message,
          error: true,
        }),
      );
    } finally {
      setLoader(false);
    }
  };
  const getSKU = (weightId) => {
    let selectedWeight = weightList?.find(
      (item) => item.weight_id == weightId,
    )?.weight_name;
    const unitName = unitList?.find((item) => item.unit_id == unit)?.unit_name;
    const subCategoryName = subCategoryList?.find(
      (item) => item.id == selectedSubCategory,
    )?.sub_category_name;

    //SKU Constaints
    let subCategoryShortName = subCategoryName
      ?.split(/\s/)
      ?.reduce((response, word) => (response += word?.slice(0, 1)), "")
      ?.toUpperCase();
    var productShortName = productName
      ?.split(/\s/)
      ?.reduce((response, word) => (response += word?.slice(0, 1)), "")
      ?.toUpperCase();
    if (unitName == "Kgs") {
      selectedWeight =
        selectedWeight.length == 1 ? selectedWeight + ".0" : selectedWeight;
    }
    var SKU =
      subCategoryShortName + "_" + productShortName + "_" + selectedWeight;
    return SKU;
  };
  const loadWeightDataById = (unitId) => {
    if (unitId) {
      setLoader(true);
      axios
        .get("/getAllActiveWeightListByUnitId/" + unitId)
        .then(function (response) {
          setWeightList(response?.data?.data || []);
        })
        .catch(function (err) {
          toast.error(err?.message || "Failed to load weight data");
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  const loadInitialData = () => {
    reset();
    setLoader(true);
    let apiCalls;
    if (id > 0) {
      apiCalls = [
        axios.get("/product/" + id),
        axios.get("/getProductList"),
        axios.get("/getAddonsList"),
      ];
    } else {
      apiCalls = [axios.get("/getProductList"), axios.get("/getAddonsList")];
    }
    axios
      .all(apiCalls)
      .then(
        axios.spread((...responses) => {
          let productResponse, productListResponse, addonsList;
          if (id > 0) {
            productResponse = responses[0];
            productListResponse = responses[1];
            addonsList = responses[2];
            setProductData(productResponse?.data?.data);
          } else {
            productListResponse = responses[0];
            addonsList = responses[1];
          }

          const activeProducts = productListResponse?.data?.data || [];
          const activeAddons = addonsList?.data?.data || [];

          // ✅ 1. Map products with variations
          const allProductsWithVariations = activeProducts.flatMap((product) =>
            (product?.variation || []).map((variation) => {
              const egg = Number(variation.egg || 0);
              const eggless = Number(variation.eggLess || 0);
              const isEggless = eggless > 0;
              const eggType = isEggless
                ? "Eggless"
                : egg > 0
                  ? "Egg"
                  : "Unknown";
              const price = isEggless ? eggless : egg;

              return {
                label: `${product.product_name} ${extractAfterLastUnderscore(
                  variation.sku,
                )} ${product?.unit?.unit_name || "Unknown"} (${eggType})`,
                value: Number(variation.variation_id),
                price,
                type: eggType,
              };
            }),
          );

          // ✅ 2. Map addons (correct key: product_name)
          const allAddons = (activeAddons || []).map((addon) => ({
            label: `${addon?.product_name} [Addon]`,
            value: Number(addon?.addon_id),
            price: Number(addon?.price || 0),
            type: "addon",
          }));
          console.log("addon", allAddons);
          // ✅ 3. Combine both into single dropdown list
          const combinedOptions = [...allProductsWithVariations, ...allAddons];

          setProductList(combinedOptions); // 👈 Used in your dropdown

          // setProductList(allProductsWithVariations);

          // if (id > 0) {
          //   // --- Combo Checkbox Logic starts here ---
          //   const product = productResponse?.data?.data;
          //   if (product?.combo_price && Number(product.combo_price) > 0) {
          //     setValue("combo_product", true);
          //   } else {
          //     setValue("combo_product", false);
          //   }

          //   if (product?.combo_products && combinedOptions.length > 0) {
          //     const selected = product.combo_products
          //       .split(",")
          //       .map((id) =>
          //         combinedOptions.find((p) => p.value === Number(id.trim()))
          //       )
          //       .filter(Boolean);

          //     setValue("selectedProducts", selected);
          //   } else {
          //     setValue("selectedProducts", []);
          //   }
          //   // --- Combo Checkbox Logic ends here ---
          // }
          if (id > 0) {
            // --- Combo Checkbox Logic starts here ---
            const product = productResponse?.data?.data;

            if (product?.combo_price && Number(product.combo_price) > 0) {
              setValue("combo_product", true);
            } else {
              setValue("combo_product", false);
            }

            // Prepare separate arrays for products and addons
            const comboProductSelections = [];
            const comboAddonSelections = [];

            // Load combo products (variation IDs)
            if (
              product?.combo_products &&
              product.combo_products !== "null" &&
              product.combo_products !== null &&
              combinedOptions.length > 0
            ) {
              const comboProductIds = product.combo_products
                .toString()
                .split(",")
                .filter((id) => id.trim());
              const comboProducts = comboProductIds
                .map((id) =>
                  combinedOptions.find((p) => p.value === Number(id.trim())),
                )
                .filter(Boolean);
              comboProductSelections.push(...comboProducts);
            }

            // Load combo addons (addon IDs)
            if (
              product?.combo_addons &&
              product.combo_addons !== "null" &&
              product.combo_addons !== null &&
              combinedOptions.length > 0
            ) {
              const comboAddonIds = product.combo_addons
                .toString()
                .split(",")
                .filter((id) => id.trim());
              const comboAddons = comboAddonIds
                .map((id) =>
                  combinedOptions.find((p) => p.value === Number(id.trim())),
                )
                .filter(Boolean);
              comboAddonSelections.push(...comboAddons);
            }

            setValue("selectedProducts", comboProductSelections);
            setValue("selectedAddons", comboAddonSelections);

            // Filter and clean variations
            let activeVariations = Array.isArray(product.variation)
              ? [...product.variation]
              : [];

            if (product.variation_ids && activeVariations.length > 0) {
              const allowedIds = String(product.variation_ids)
                .split(",")
                .map((v) => Number(v.trim()))
                .filter((v) => !isNaN(v) && v > 0);

              if (allowedIds.length > 0) {
                const filtered = activeVariations.filter((v) =>
                  allowedIds.includes(Number(v.variation_id || v.id))
                );
                if (filtered.length > 0) {
                  activeVariations = filtered;
                }
              }
            }

            // Deduplicate variations by weight_id (keep latest)
            const weightMap = new Map();
            for (const v of activeVariations) {
              const wId = v.weight_id ?? v.weight;
              if (
                !weightMap.has(wId) ||
                (v.variation_id &&
                  v.variation_id > (weightMap.get(wId).variation_id || 0))
              ) {
                weightMap.set(wId, v);
              }
            }
            activeVariations = Array.from(weightMap.values());

            const mappedVariations = activeVariations.map((v) => ({
              id: v.variation_id || v.id || null,
              variation_id: v.variation_id || v.id || null,
              weight:
                v.weight !== "" && v.weight !== undefined
                  ? Number(v.weight)
                  : v.weight_id !== "" && v.weight_id !== undefined
                  ? Number(v.weight_id)
                  : "",
              weight_id:
                v.weight_id !== "" && v.weight_id !== undefined
                  ? Number(v.weight_id)
                  : v.weight !== "" && v.weight !== undefined
                  ? Number(v.weight)
                  : "",
              egg: String(v.egg ?? ""),
              eggLess: String(v.eggLess ?? v.eggless ?? "0"),
              eggless: String(v.eggLess ?? v.eggless ?? "0"),
              eggPreparation:
                v.egg_preparation && Number(v.egg_preparation) > 0
                  ? String(v.egg_preparation)
                  : v.eggPreparation && Number(v.eggPreparation) > 0
                  ? String(v.eggPreparation)
                  : "",
              egg_preparation:
                v.egg_preparation && Number(v.egg_preparation) > 0
                  ? String(v.egg_preparation)
                  : v.eggPreparation && Number(v.eggPreparation) > 0
                  ? String(v.eggPreparation)
                  : "",
              egglessPreparation:
                v.eggless_preparation && Number(v.eggless_preparation) > 0
                  ? String(v.eggless_preparation)
                  : v.egglessPreparation && Number(v.egglessPreparation) > 0
                  ? String(v.egglessPreparation)
                  : "",
              eggless_preparation:
                v.eggless_preparation && Number(v.eggless_preparation) > 0
                  ? String(v.eggless_preparation)
                  : v.egglessPreparation && Number(v.egglessPreparation) > 0
                  ? String(v.egglessPreparation)
                  : "",





              sku: v.sku || "",
            }));

            const mappedRegions = (product.region || []).map((item) => ({
              value: item.id,
              label:
                item?.itemName?.city?.name ||
                item?.itemName?.address ||
                String(item.id),
            }));

            const mappedFlavours = (product.flavour || []).map((item) => ({
              value: item.id,
              label: item?.itemName || String(item.id),
            }));

            const codList = [];
            if (Number(product.COD_egg) === 1) codList.push("egg");
            if (Number(product.COD_eggless) === 1) codList.push("eggless");

            reset({
              category_id: product.category_id,
              sub_category_id: product.sub_category_id,
              product_name: product.product_name || "",
              product_description: product.product_description || "",
              short_description: product.short_description || "",
              hsn: product.hsn || "",
              tax_id: product.tax_id,
              unit_id: product.unit_id,
              product_price: String(product.product_price ?? "0"),
              base_eggless_price: String(product.base_eggless_price ?? "0"),
              ratings: String(product.ratings ?? "4.5"),
              cat_code_id: product.cat_code_id || "",
              cod: codList,
              shape_id: product.shape_id || "",
              stream_engine: product.stream_engine === 1,
              region: mappedRegions,
              flavour: mappedFlavours,
              variation: mappedVariations,
              combo_product:
                product?.combo_price && Number(product.combo_price) > 0,
              selectedProducts: comboProductSelections,
              selectedAddons: comboAddonSelections,
              offer_fixed_price_id: product.offer_fixed_price_id || null,
              product_tags: product.all_region_product_tags || [],
            });

            setValue("category_id", product.category_id);
            setValue("sub_category_id", product.sub_category_id);
            setValue("product_name", product.product_name || "");
            setValue("product_description", product.product_description || "");
            setValue("short_description", product.short_description || "");
            setValue("hsn", product.hsn || "");
            setValue("tax_id", product.tax_id);
            setValue("unit_id", product.unit_id);
            setValue("product_price", String(product.product_price ?? "0"));
            setValue("base_eggless_price", String(product.base_eggless_price ?? "0"));
            setValue("ratings", String(product.ratings ?? "4.5"));
            setValue("cat_code_id", product.cat_code_id || "");
            setValue("cod", codList);
            setValue("shape_id", product.shape_id || "");
            setValue("stream_engine", product.stream_engine === 1);
            setValue("region", mappedRegions);
            setValue("flavour", mappedFlavours);
            setValue("variation", mappedVariations);

            setProductData({
              ...product,
              variation: activeVariations,
            });
            // --- Combo Checkbox Logic ends here ---
          }
        }),
      )
      .catch(function (err) {
        toast.error(err?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  return loader ? (
    <Loader />
  ) : (
    <div>
      <div className="d-flex ">
        <ArrowBackIcon
          className="text-danger"
          sx={{ marginRight: "1rem", cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h4 className="text-primary">{id ? "Edit Product" : "New Product"}</h4>
      </div>

      <Paper
        elevation={1}
        sx={{
          p: 3,
          margin: "auto",
          marginTop: "15px",
          flexGrow: 1,
        }}
      >
        <Grid container columnSpacing={{ xs: 4 }}>
          <Grid item xs={6}>
            <Controller
              defaultValue={productData?.category_id}
              render={({ field: { onChange, value } }) => {
                return (
                  <FormControl
                    fullWidth
                    error={errors?.["category_id"]?.message ? true : false}
                    margin="normal"
                  >
                    <InputLabel id="category_id_label"> Category</InputLabel>
                    <Select
                      labelId="category_id_label"
                      id={`category_id_select`}
                      value={value ?? productData?.category_id ?? ""}
                      // value={value || ""}
                      label="Category"
                      onChange={onChange}
                    >
                      <MenuItem value={""} key={0}>
                        --SELECT--
                      </MenuItem>
                      {categoryList?.map((item) => (
                        <MenuItem value={item?.id} key={item?.id}>
                          {item?.category_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                );
              }}
              control={control}
              name={"category_id"}
            />
          </Grid>
          <Grid item xs={6}>
            {/* <Controller
              defaultValue={productData?.sub_category_id}
              render={({ field: { onChange, value } }) => {
                return (
                  <FormControl
                    fullWidth
                    error={errors?.["sub_category_id"]?.message ? true : false}
                    margin="normal"
                  >
                    <InputLabel id="sub_category_id_label">
                      Sub Category
                    </InputLabel>
                    <Select
                      labelId="sub_category_id_label"
                      id={`sub_category_id_select`}
                      // value={value || productData?.sub_category_id}
                      value={value || productData?.category_id || ""} 
                      // value={value}
                      label="Sub Category"
                      onChange={onChange}
                    >
                      <MenuItem value={""} key={0}>
                        --SELECT--
                      </MenuItem>
                      {filteredSubCategories?.map((item) => (
                        <MenuItem value={item?.id} key={item?.id}>
                          {item?.sub_category_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                );
              }}
              control={control}
              name={"sub_category_id"}
            /> */}
            <Controller
              defaultValue={productData?.sub_category_id || ""}
              render={({ field: { onChange, value } }) => {
                return (
                  <FormControl
                    fullWidth
                    error={!!errors?.["sub_category_id"]?.message}
                    margin="normal"
                  >
                    <InputLabel id="sub_category_id_label">
                      Sub Category
                    </InputLabel>
                    <Select
                      labelId="sub_category_id_label"
                      id="sub_category_id_select"
                      value={value ?? ""}
                      label="Sub Category"
                      onChange={onChange}
                    >
                      <MenuItem value={""} key={0}>
                        --SELECT--
                      </MenuItem>
                      {filteredSubCategories?.map((item) => (
                        <MenuItem value={item?.id} key={item?.id}>
                          {item?.sub_category_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                );
              }}
              control={control}
              name={"sub_category_id"}
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputText
              name="product_name"
              control={control}
              label="Product Name"
              errors={errors}
              mandatory="true"
              defaultValue={productData?.product_name}
            />
          </Grid>
          <Grid item xs={6} sx={{ marginTop: "10px" }}>
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Controller
                      name="combo_product"
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value}
                          color="primary"
                        />
                      )}
                    />
                  }
                  label="Combo Product"
                />
              </Grid>

              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Controller
                      name="product_shape"
                      control={control}
                      defaultValue={productData?.shape_id > 0 || false}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value}
                          color="primary"
                        />
                      )}
                    />
                  }
                  label="Product Shape"
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Controller
                      name="stream_engine"
                      control={control}
                      defaultValue={productData?.stream_engine === 1 || false}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={!!field.value}
                          color="primary"
                          onChange={(e) =>
                            field.onChange(e.target.checked ? 1 : 0)
                          }
                        />
                      )}
                    />
                  }
                  label="Stream Engine"
                />
              </Grid>
            </Grid>
            {/* <Grid item xs={12} container spacing={2}>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Controller
                      name="pick_up"
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value}
                          color="primary"
                        />
                      )}
                    />
                  }
                  label="Pick Up"
                />
              </Grid>

              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Controller
                      name="door_step_delivery"
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value}
                          color="primary"
                        />
                      )}
                    />
                  }
                  label="Door Delivery"
                />
              </Grid>
            </Grid> */}
          </Grid>

          {comboProductChecked && (
            <>
              <Grid item xs={6} sx={{ marginTop: "8px" }}>
                <FormAutoComplete
                  id="selectedProducts"
                  name="selectedProducts"
                  control={control}
                  label="Combo Products"
                  multiple
                  dataArray={productList?.filter((p) => p.type !== "addon")}
                  errors={errors}
                  mandatory="true"
                  value={selectedProducts}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                />
              </Grid>

              <Grid item xs={3} sx={{ marginTop: "-8px" }}>
                <FormInputText
                  name="combo_price"
                  control={control}
                  label="Combo Price"
                  errors={errors}
                  mandatory="true"
                  defaultValue={productData?.combo_price || 0}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid
                item
                xs={3}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "-8px",
                }}
              >
                <Typography variant="subtitle2" sx={{ ml: 2, pb: 2 }}>
                  Total Combo Price: ₹{totalComboPrice || 0}
                </Typography>
              </Grid>
              <Grid item xs={6} sx={{ marginTop: "8px" }}>
                <FormAutoComplete
                  id="selectedAddons"
                  name="selectedAddons"
                  control={control}
                  label="Combo Addons"
                  multiple
                  dataArray={productList?.filter((p) => p.type === "addon")}
                  errors={errors}
                  mandatory="false"
                  value={selectedAddons}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                />
              </Grid>
            </>
          )}
          <Grid item xs={3}>
            <Controller
              defaultValue={productData?.unit_id}
              render={({ field: { onChange, value } }) => {
                return (
                  <FormControl
                    fullWidth
                    error={errors?.["unit_id"]?.message ? true : false}
                    margin="normal"
                  >
                    <InputLabel id="unit_id_label"> Unit</InputLabel>
                    <Select
                      labelId="unit_id_label"
                      id={`unit_id_select`}
                      value={value ?? productData?.unit_id ?? ""}
                      label="Category"
                      onChange={onChange}
                    >
                      <MenuItem value={""} key={0}>
                        --SELECT--
                      </MenuItem>
                      {unitList?.map((item) => (
                        <MenuItem value={item?.unit_id} key={item?.unit_id}>
                          {item?.unit_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                );
              }}
              control={control}
              name={"unit_id"}
            />
          </Grid>
          {!comboProductChecked && (
            <>
              <Grid item xs={3}>
                <Controller
                  name={`hsn`}
                  control={control}
                  defaultValue={productData?.hsn || ""}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      label="HSN / SAC Code"
                      variant="outlined"
                      onChange={onChange}
                      value={value || ""}
                      error={error?.message ? true : false}
                      margin="normal"
                      defaultValue={productData?.hsn}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="tax_id"
                  control={control}
                  defaultValue={productData?.tax_id || ""}
                  render={({ field: { onChange, value } }) => (
                    <FormControl fullWidth margin="normal">
                      <InputLabel id="tax_id_label">Tax</InputLabel>
                      <Select
                        labelId="tax_id_label"
                        id="tax_id_select"
                        value={value ?? ""}
                        onChange={onChange}
                        label="Tax"
                      >
                        <MenuItem value="">-- SELECT --</MenuItem>
                        {taxList?.map((item) => (
                          <MenuItem value={item.tax_id} key={item.tax_id}>
                            {`${item.tax_percentage} %`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>
            </>
          )}
          {productShape && (
            <Grid item xs={3}>
              <Controller
                defaultValue={productData?.shape_id || ""}
                render={({ field: { onChange, value } }) => {
                  return (
                    <FormControl
                      fullWidth
                      error={errors?.["shape_id"]?.message ? true : false}
                      margin="normal"
                    >
                      <InputLabel id="shape_id_label">Shape</InputLabel>
                      <Select
                        labelId="shape_id_label"
                        id="shape_id_select"
                        value={value ?? ""}
                        label="Shape"
                        onChange={onChange}
                      >
                        <MenuItem value={""} key={0}>
                          --SELECT--
                        </MenuItem>
                        {shapeList?.map((item) => (
                          <MenuItem value={item?.shape_id} key={item?.shape_id}>
                            {item?.shape_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                }}
                control={control}
                name={"shape_id"}
              />
            </Grid>
          )}
          <Grid item xs={3} sx={{ mt: 2 }}>
            <FormAutoComplete
              name="region"
              control={control}
              label="Region"
              multiple={true}
              dataArray={regionList?.map((item) => ({
                value: item?.region_id,
                label: item?.city?.name,
              }))}
              errors={errors}
              defaultValue={productData?.region?.map((item) => ({
                value: item?.id,
                label: item?.itemName?.city?.name,
              }))}
              mandatory="true"
            />
          </Grid>

          <Grid item xs={3} sx={{ mt: 2 }}>
            <FormAutoComplete
              name="flavour"
              control={control}
              label="Flavour"
              multiple={true}
              errors={errors}
              defaultValue={productData?.flavour?.map((item) => ({
                value: item?.id,
                label: item?.itemName,
              }))}
              dataArray={flavourList?.map((item) => ({
                value: item?.flavour_id,
                label: item?.flavour_name,
              }))}
              mandatory="true"
            />
          </Grid>

          <Grid item xs={3}>
            <FormInputText
              name="ratings"
              control={control}
              label="Ratings"
              errors={errors}
              mandatory="true"
              defaultValue={productData?.ratings}
            />
          </Grid>
          <Grid item xs={3}>
            <Controller
              defaultValue={productData?.cat_code_id || ""}
              render={({ field: { onChange, value } }) => {
                return (
                  <FormControl
                    fullWidth
                    error={errors?.["cat_code_id"]?.message ? true : false}
                    margin="normal"
                  >
                    <InputLabel id="cat_code_id_label">
                      Category Code
                    </InputLabel>
                    <Select
                      labelId="cat_code_id_label"
                      id="cat_code_id_select"
                      value={value || ""}
                      label="Category Code"
                      onChange={onChange}
                    >
                      <MenuItem value={""} key={0}>
                        --SELECT--
                      </MenuItem>
                      {categoryCodeList?.map((item) => (
                        <MenuItem
                          value={item?.cat_code_id || item?.id}
                          key={item?.cat_code_id || item?.id}
                        >
                          {item?.category_code}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                );
              }}
              control={control}
              name={"cat_code_id"}
            />
          </Grid>
          <></>
          <Grid
            item
            xs={3}
            sx={{ mt: "8px", display: "flex", alignItems: "center" }}
          >
            <Button
              onClick={handleProductMultiRegion}
              size="small"
              sx={{
                maxHeight: "40px",
                textTransform: "capitalize",
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              Configure New Arrival & Best Seller
            </Button>
          </Grid>
          {/* <Grid item xs={3}>
            <Controller
              defaultValue={productData?.offer_fixed_price_id || ""}
              render={({ field: { onChange, value } }) => (
                <FormControl
                  fullWidth
                  error={!!errors?.["offer_fixed_price_id"]?.message}
                  margin="normal"
                >
                  <InputLabel id="offer_fixed_price_id_label">
                    Flat Price
                  </InputLabel>
                  <Select
                    labelId="offer_fixed_price_id_label"
                    id="offer_fixed_price_id_select"
                    value={value || ""}
                    label="Flat Price"
                    onChange={onChange}
                  >
                    <MenuItem value="" key={0}>
                      --SELECT--
                    </MenuItem>
                    {flatPriceList?.map((item) => (
                      <MenuItem value={item?.id} key={item?.id}>
                        ₹{item?.fixed_price}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              control={control}
              name={"offer_fixed_price_id"}
            />
          </Grid> */}
          <Grid item xs={2} sx={{ marginTop: "8px" }}>
            <FormInputMultiCheckbox
              control={control}
              setValue={setValue}
              name={"cod"}
              label={"Cash On Delivery"}
              defaultValue={
                Number(productData?.COD_egg) === 1 || Number(productData?.COD_eggless) === 1
                  ? [
                      ...(Number(productData?.COD_egg) === 1 ? ["egg"] : []),
                      ...(Number(productData?.COD_eggless) === 1 ? ["eggless"] : []),
                    ]
                  : []
              }
              checkBoxoptions={[
                {
                  label: "Egg",
                  value: "egg",
                },
                {
                  label: "Eggless",
                  value: "eggless",
                },
              ]}
            />
          </Grid>
        </Grid>
        <Divider
          variant="middle"
          className="text-primary"
          sx={{
            margin: "32px auto",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          Descriptions
        </Divider>
        <Grid container columnSpacing={{ xs: 5 }}>
          {/* <Grid item xs={6}>
            <FormTextEditor
              name="product_description"
              control={control}
              label="Product Description"
              errors={errors}
              defaultValue={productData?.product_description}
            />
          </Grid> */}
          <Grid item xs={6}>
            <FormInputTextArea
              name="short_description"
              control={control}
              label="Description"
              minRows={2}
              maxRows={15}
              placeholder={"Description"}
              errors={errors}
              mandatory="true"
              defaultValue={productData?.short_description}
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputTextArea
              name="product_description"
              control={control}
              label="Care Instruction"
              minRows={2}
              maxRows={15}
              placeholder={"Care Instruction"}
              errors={errors}
              mandatory="true"
              defaultValue={productData?.product_description}
            />
          </Grid>

          {/* <Grid item xs={6}>
            <FormTextEditor
              name="short_description"
              control={control}
              label="Short Description"
              errors={errors}
              defaultValue={productData?.short_description}
            />
          </Grid> */}
        </Grid>
        <Divider
          variant="middle"
          className="text-primary"
          sx={{ margin: "32px auto", fontSize: "16px", fontWeight: "bold" }}
        >
          Pricing
        </Divider>
        <Grid container columnSpacing={{ xs: 5 }}>
          <Grid item xs={6}>
            <FormInputText
              name="product_price"
              control={control}
              label="Base Egg Price"
              errors={errors}
              mandatory="true"
              defaultValue={`${productData?.product_price}` || "0"}
            />
            <Typography variant="subtitle2" gutterBottom color={"error"}>
              (NOTE: Base Price For 0.5 Kg)
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <FormInputText
              name="base_eggless_price"
              control={control}
              label="Base Eggless Price"
              errors={errors}
              mandatory="true"
              defaultValue={productData?.base_eggless_price || 0}
            />
            <Typography variant="subtitle2" gutterBottom color={"error"}>
              (NOTE: Base Price For 0.5 Kg)
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "24px" }}>
            <ProductVariation
              variationValue={productData?.variation || []}
              control={control}
              getSKU={getSKU}
              weightList={weightList}
              setValue={setValue}
              getValues={getValues}
              type={id > 0 ? "UPDATE" : "CREATE"}
              onDeleteVariation={(delId) =>
                setDeletedVariationIds((prev) => [...prev, delId])
              }
              // flavourList={flavourList}
              // selectedFlavours={selectedFlavours}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginTop: "24px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={handleSubmit(onSubmit)}
              variant="contained"
              sx={{ paddingLeft: "32px", paddingRight: "32px" }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <ProductMultiRegion
        open={openMultiRegion}
        onClose={handleCloseMultiRegion}
        selectedRegions={selectedRegions || []}
        onSave={handleMultiRegionSave}
        data={productData?.all_region_product_tags || []}
      />
    </div>
  );
}

export default ProductForm;
